import { ComputeFieldComponent } from "../computeFields";
import { Document } from "../types";
import { SeparatedList } from "./shared/utils";
import { t } from "i18next";

export const DocumentSummaryCF: ComputeFieldComponent<
  Pick<
    Document,
    | "documentsDescriptionTitre"
    | "documentsDescriptionLieuDeCreation"
    | "documentsDescriptionDate"
    | "documentsDescriptionType"
    | "documentsDescriptionPhotographe"
    | "documentsDescriptionCopyright"
  >
> = ({ input, language, ...props }) => (
  <SeparatedList
    {...props}
    commaSeparated={false}
    language={language}
    input={[
      <SeparatedList
        {...props}
        endWithPeriod
        language={language}
        input={[
          input.documentsDescriptionTitre,
          input.documentsDescriptionLieuDeCreation,
          input.documentsDescriptionDate,
        ]}
      />,

      <SeparatedList
        {...props}
        commaSeparated={false}
        language={language}
        input={[
          <SeparatedList
            endWithPeriod
            language={language}
            input={[
              input.documentsDescriptionType &&
                `- ${input.documentsDescriptionType}`,
            ]}
          />,
          input.documentsDescriptionPhotographe &&
            `${t("computeField.photoCredit", { lng: language })} : ${input.documentsDescriptionPhotographe}`,
          input.documentsDescriptionCopyright &&
            `© ${input.documentsDescriptionCopyright}`,
        ]}
      />,
    ]}
  />
);
